export const comments_3389024 = {"data":{"data":[],"links":{}}}